/**
 * Shared formatting helpers.
 */
import i18n from "@/lib/i18n";

/** Format an ISO date (YYYY-MM-DD) to a locale-aware DD/MM/YYYY string. */
export function formatDate(iso) {
  if (!iso) return "";
  const d = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(d.getTime())) return iso;
  try {
    return d.toLocaleDateString(i18n.language === "fr" ? "fr-FR" : "en-US", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch (e) {
    return iso;
  }
}
